import * as Yup from "yup";
import MESSAGE from "~/utils/messages";
import {
  phoneDDDValidation,
  phoneWithOutDDDValidation,
  cpfValidation,
} from "~/utils/tools";

export const schema = Yup.object().shape({
  Documento: Yup.mixed().when("CPFView", {
    is: false,
    then: Yup.mixed()
      .required(MESSAGE.requiredField)
      .test({
        name: "cpf",
        message: MESSAGE.invalidCPF,
        test: (value) => value && cpfValidation(value),
      }),
    otherwise: Yup.mixed(),
  }),
  Estado: Yup.object().shape({
    label: Yup.string().required(MESSAGE.requiredSelect),
    value: Yup.string().required(MESSAGE.requiredSelect),
    id: Yup.number().required(MESSAGE.requiredSelect),
  }),
  TelefoneTipo: Yup.object().shape({
    label: Yup.string().required(MESSAGE.requiredSelect),
    value: Yup.string().required(MESSAGE.requiredSelect),
    id: Yup.number().required(MESSAGE.requiredSelect),
  }),
  DDDTelefone: Yup.mixed()
    .required(MESSAGE.requiredCheck)
    .test({
      name: "DDDTelefone",
      message: MESSAGE.invalidDDD,
      test: (value) => {
        if (value) {
          return phoneDDDValidation(value);
        }
        return false;
      },
    }),
  Telefone: Yup.mixed()
    .required(MESSAGE.requiredCheck)
    .test({
      name: "Telefone",
      message: MESSAGE.invalidPhone,
      test: (value) => {
        if (value) {
          return phoneWithOutDDDValidation(value);
        }
        return false;
      },
    }),
  AceitaTermosLegais: Yup.array()
    .of(Yup.string())
    .required(MESSAGE.requiredCheck),
  AceitaRegulamento: Yup.array()
    .of(Yup.string())
    .required(MESSAGE.requiredCheck),
  AceitaReceberNoticias: Yup.array().nullable(),
  AceitaPoliticaDePrivacidade: Yup.array()
    .of(Yup.string())
    .required(MESSAGE.requiredCheck),
});
